export default __webpack_public_path__ + "static/media/LogoASC.286181a3.png";